module.exports = __webpack_public_path__ + "img/mydomain.f7341c59.jpg";